import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_elwnrzazbf: FaireBrandEntity = {
  token: "b_elwnrzazbf",
  type: "brand",
  name: "Microcosm Publishing & Distribution",
  avatarUrl:
    "https://cdn.faire.com/fastly/321e46853b3a5d965b9b4145b90d63dc11d3f3e9f1d622118edc366dcc620cb2.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/d2a75213bc8210247aeefbd4498029d44bc5ff8fb501c6e82e7f446b526ed690.png",
  logoUrl:
    "https://cdn.faire.com/fastly/321e46853b3a5d965b9b4145b90d63dc11d3f3e9f1d622118edc366dcc620cb2.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/d2a75213bc8210247aeefbd4498029d44bc5ff8fb501c6e82e7f446b526ed690.png",
  location: "Portland, OR, USA",
  minimumOrderDollars: 139,
  rating: 4.9,
  reviewCount: 1399,
  isTopShop: true,
  isInsider: true,
  description:
    "Microcosm Publishing is a fiercely independent publisher and distributor that empowers readers to make positive changes in their lives, their communities, and their world.\n\nOur books and zines focus on subjects like gender, self-care, mental health, bicycle culture, punk rock, radical politics, witchcraft, social justice, bodily autonomy, and a community-focused DIY ethos. \n\nWe built a successful book business by celebrating all the things that mainstream publishing deems too niche or incendiary to take on—and we're growing all the time, thanks to people like you! We also create stickers, pins, patches, card decks, and other unique products to help you express yourself, explore your relationships, and expand your horizons.\n\nWe began in Cleveland, OH in 1996 and now based out of Cleveland and Portland, OR. In the beginning, we set out to save ourselves from not caring. But out here in the margins, we found inspiration in countless folks and communities who make us want to do more, and better. We've professionalized a little from our punk roots (where once we had zines in a milk crate, we now have warehouses), but Microcosm is still fueled by the dream of a better world, motivating us to share the resource we need to get started building it, right now, together.",
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:52:32.416Z",
    importedBy: "entity-db-cli",
  },
};
